export default "__VITE_ASSET__DfmgVAAA__"